<template >
  [WikiInputUrl]
  <div class="input-group">
    <div class="input-group-text">
      {{typeTitle}}
    </div>
    <input
        :type="options.inputType"
        v-model="inputModel"
        class="form-control"
    />
    <div class="input-group-text">
      <i class="bi bi-zoom-in"></i>
    </div>
  </div>

  <div
      v-if="inputModel && isValid === false"
      class="text-danger"
  >
    nevalidni {{errMessage}}
  </div>


  <!--
  <display-debug>
    <template #debugView>options {{options}}</template>
  </display-debug>
-->

</template>

<script>


import axios from "axios";
const texts ={
  ident: {
    facebook_profile: {
      cz: 'Facebook X',
      en: 'Facebook',
    }
  }
};
let timer;

export default {
  name: "WikiInputUrl",
  components: {

  },
  props: {
    "modelValue": {
      type: [String, Number, Object],
      required: false,
      default: null
    },
    "langs": [String, Object],
    "parentIndex": [String, Number],
    "options": {
      type: Object,
      required: false,
      default: {}
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      typeId: null,
      writeStatus: false,
      inputModel: null,
      isValid: null,
      errMessage: null
    }
  },
  created() {

  },
  mounted() {
    this.typeId = this.options.meta.type;
    if(this.modelValue) {
      if(typeof this.modelValue.isValid != "undefined") this.modelValue.isValid = this.modelValue.isValid;
      if(typeof this.modelValue.isPreview != "undefined") this.modelValue.isValid = this.modelValue.isPreview;
      if(typeof this.modelValue.value != "undefined") this.inputModel = this.modelValue.value;
    }
  },
  methods: {
    async checkUrl(value) {
      //console.log('dev.url checkUrl', value)

      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.getApiConfig('wiki.check_url.path')
      apiPath += '?' + this.getApiConfig('wiki.check_url.input.url') + '=' + value;
      apiPath += '&' + this.getApiConfig('wiki.check_url.input.type') + '=' + this.typeId;
      await axios({
        //url: this.getApiConfig('general.format_slug.path') + "?" + this.getApiConfig('general.format_slug.input.slug') +"=" + value[l],
        url: apiPath,
        method: this.getApiConfig('wiki.check_url.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        console.log('dev.url checkUrl DATA', res.data)
        if(res.data.status){
          this.isValid = true;
          /*
          if(res.data.response.slug && res.data.response.slug != "null"){
            value[l] = res.data.response.slug;
          }
          */
        }else{
          this.isValid = false;
          this.errMessage = res.data.err.message
        }
      }).catch((err) => {
        console.log("dev format slug catch", err)
      })



    },

  },
  computed: {
    typeTitle() {
      if(typeof texts.ident[this.typeId] != "undefined"){
        return texts.ident[this.typeId].cz;
      }else{
        return 'URL';
      }
    }
  },
  watch: {
    "modelValue.value": {
      handler(newVal) {
        this.inputModel = newVal;
      },
      deep: true,
      immediate: true
    },

    /*
    options: {
      handler(newVal) {
        if(newVal && newVal.is_slug){
          for(const l in newVal.makeFrom) {
          }
        }
      },
      deep: true,
      immediate: true
    },
    */
    inputModel: {
      handler(newVal) {
        if(timer) clearInterval(timer);
        timer = setTimeout(
            () => {
              if(newVal) {
                this.checkUrl(newVal);

              }
              const exportData = {
                value: newVal,
                isValid: this.isValid,
                isPreview: false,

              }


              this.$emit('update:modelValue', exportData )
            },
            300
        )
      },
      deep: true,
      immediate: true
    },

  },
};
</script>